import { useTranslations } from "next-intl";

const Index = ({
	label,
	placeholder,
	id,
	name,
	input_style,
	label_style,
	label_toolbar,
	required,
	className,
	value,
	onChange,
	errors,
	minLength,
	maxLength,
	rows,
	disabled
}) => {
	const t = useTranslations();
	const hasError = errors?.length > 0;

	// ارور یا کلید ترجمه است یا متن آماده‌ی فارسی که ولیدیتورها برمی‌گردانند
	const error_message = (error) => {
		if (!error) return "";
		return typeof error === "string" && t.has(error) ? t(error) : error;
	};

	return (
		<div className={`relative w-full ${className || ""}`}>
			<div className="input-wrapper">
				{label &&
					<div className="label-parent w-full flex items-center justify-between gap-1 mb-1.5">
						<label
							htmlFor={id}
							className={`relative text-sm ${disabled ? 'text-jmt-neutral-300' : 'text-jmt-main'} ${label_style || ""}`}>
							{required && (
								<span className="absolute top-0 -left-3 text-jmt-red-500">
									*
								</span>
							)}
							{label}
						</label>
						{label_toolbar && label_toolbar}
					</div>
				}

				<textarea
					placeholder={placeholder}
					name={name}
					id={id}
					value={value || ""}
					onChange={onChange}
					disabled={disabled}
					minLength={minLength}
					maxLength={maxLength}
					rows={rows}
					required={required}
					className={`
						default-text-area w-full outline-0 text-sm border rounded-md py-2 px-3 transition-all duration-200
						
						{/* disabled  */}
						${disabled ? 'bg-jmt-white text-jmt-neutral-300 border-jmt-neutral-200 cursor-not-allowed' : ''}

						/* base */
						${!hasError && !disabled ? 'border-jmt-neutral-300 hover:border-jmt-neutral-500' : ''}

						/* focus */
						${!hasError ? 'focus:ring-2 focus:ring-jmt-neutral-600 focus:ring-offset-2' : ''}

						/* error */
						${hasError ? 'border-jmt-red-500 focus:ring-2 focus:ring-jmt-red-500 focus:ring-offset-2' : ''}

						${input_style || ''}
					`}
				/>
			</div>

			{hasError &&
				<div className="mt-1 text-xs flex text-jmt-red-600 animate-fade">
					{error_message(typeof errors === "string" ? errors : errors?.[0])}
				</div>
			}
		</div>
	);
};

export default Index;
